import Button from "../../components/Button";
import {
  useNavigate,
} from "react-router-dom";
import { useStore } from "../../store";
import { observer } from "mobx-react-lite";
import { useMemo, useState } from "react";
import { Recipe } from "../../store/backend";
import './recipe.css';
import { RecipeDetailModal, RecipeDetailModalProps } from "./DetailModal";
function Menu() {
  const navigate = useNavigate();
  const { dataStore } = useStore();
  const resData = dataStore.resData;
  const [detailModal, setDetailModal] = useState<RecipeDetailModalProps & { key?: any }>({})
  const recipes = useMemo(() => {

    const ary: (Recipe | null)[] = []
    for (let index = 0; index < 9; index++) {
      let data: (Recipe | null)
      if (resData?.recipesAck) {
        data = resData.recipesAck[index] || null
      } else {
        data = null
      }

      ary.push(data)

    }

    return ary

  }, [resData.recipesAck])

  const onStart = async (id: string) => {

    navigate('/')

    if (resData.activeLogAck?.state !== 'DRAFT') {

      await new Promise((resolve, reject) => {

        dataStore.sendData({
          action: 'stopProgram',
          data: {},
        });
        setTimeout(() => {
          resolve({})
        }, 200);
      })

    }

    dataStore.sendData({
      action: 'startRecipeProgram',
      data: {
        id,
      },
    });

  }

  const recipeView = (recipe: Recipe) => {
    return (
      <div
        onClick={() => setDetailModal({ recipe, key: Date.now(), isOpen: true, onStart: e => onStart(e), startButtonDisabled: resData.activeLogAck?.state !== 'DRAFT' })}
        className="flex"
        style={{
          left: 0,
          top: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          color: 'white',
        }}
      >
        <div
          style={{
            fontSize: 80,
          }}
        >
          {recipe.icon}
        </div>
        <div
          style={{
            fontSize: 24,
            fontWeight: 'bold',
            marginBottom: 5,
          }}
        >
          {recipe.name}
        </div>
        <div
          style={{
            fontSize: 16,
            opacity: 0.8,
          }}
        >
          {recipe.subtitle}
        </div>
        <div
          style={{
            position: 'absolute',
            bottom: 10,
            left: 10,
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            padding: '4px 8px',
            borderRadius: 12,
            fontSize: 12,
          }}
        >
          {recipe.subDuration}
        </div>
      </div>
    )
  }

  return (
    <div className="flex bg-quickStartPrimaryBgColor"
      style={{
        position: 'absolute',
        height: 730,
        width: 1280,
      }}
    >

      <div
        className="flex"
        style={{
          flexDirection: 'row',
          flex: 1,
        }}
      >
        <Button
          options={{
            text: "RETURN",
            cb: () => navigate(-1),
          }}
          style={{
            padding: "0px 40px",
            boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
            backgroundColor: "#406F70",
            marginLeft: "55px",
            marginRight: "55px",
            alignSelf: 'center',
          }}
        />
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)', // 三列
            gap: '10px', // 统一格子间距
            backgroundColor: "#406F70",
            flex: 1,
            margin: 30,
            marginLeft: 0,
            borderRadius: 20,
            boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.3)',
            padding: '10px', // 让外围空隙与内部 gap 一致
          }}
        >
          {recipes.map((recipe, index) => (
            <div
              className="recipe-item"
              key={index}
              style={{
                borderWidth: 2,
                borderRadius: 5,
                borderColor: 'rgba(0,0,0,0.3)',
                position: 'relative',
              }}
            >
              {recipe ? recipeView(recipe) : <div />}
            </div>
          ))}
        </div>
      </div>

      <RecipeDetailModal
        {...detailModal}
        onCancel={() => {
          setDetailModal({ ...detailModal, isOpen: false })
        }}
      />
    </div>
  );
}
export default observer(Menu);
